'use es6';
/**
 * Input: <line:ch>, 11, 11:, 11:22
 * Matches: [input, line, ch]
 *
 * @type {RegExp} Matches input for the "Jump To Line" find feature.
 */

export const JUMP_TO_LINE_REGEX = /^(\d+)(?:(?::)(\d*))?$/;